import {formatarValor, formatarValorComCasas, formatarValorMonetario} from "@/helpers";

export const status_analise = {
  estoque_em_preco_custo: {
    descricao: 'Estoque Total (R$ custo)',
    valor_data_inicial: {
      formatador: formatarValorMonetario,
    },
    valor_data_final: {
      formatador: formatarValorMonetario,
    },
    diferenca_em_valor: {
      formatador: formatarValorMonetario,
      indicador: {
        positivo: { cor: 'green' },
        negativo: { cor: 'red' },
      }
    },
    diferenca_em_porcentagem: {
      formatador: valor => `${formatarValorComCasas(valor, 1)}%`,
      indicador: {
        positivo: { cor: 'green' },
        negativo: { cor: 'red' },
      }
    },
  },
  estoque_em_excesso_em_preco_custo: {
    descricao: 'Estoque em Excesso (R$ custo)',
    valor_data_inicial: {
      formatador: formatarValorMonetario,
    },
    valor_data_final: {
      formatador: formatarValorMonetario,
    },
    diferenca_em_valor: {
      formatador: formatarValorMonetario,
      indicador: {
        positivo: { cor: 'red' },
        negativo: { cor: 'green' },
      }
    },
    diferenca_em_porcentagem: {
      formatador: valor => `${formatarValorComCasas(valor, 1)}%`,
      indicador: {
        positivo: { cor: 'red' },
        negativo: { cor: 'green' },
      }
    },
  },
  estoque_versos_excesso_em_porcentual: {
    descricao: 'Estoque em Excesso x Estoque Total (%)',
    valor_data_inicial: {
      formatador: valor => `${formatarValor(valor)}%`,
    },
    valor_data_final: {
      formatador: valor => `${formatarValor(valor)}%`,
    },
    diferenca_em_valor: {
      formatador: valor => `${formatarValor(valor)}%`,
      indicador: {
        positivo: { cor: 'red' },
        negativo: { cor: 'green' },
      }
    },
    diferenca_em_porcentagem: {
      formatador: valor => `${formatarValorComCasas(valor, 1)}%`,
      indicador: {
        positivo: { cor: 'red' },
        negativo: { cor: 'green' },
      }
    },
  },
  estoque_saudavel_em_preco_custo: {
    descricao: 'Estoque Saudável (R$ custo)',
    valor_data_inicial: {
      formatador: formatarValorMonetario,
    },
    valor_data_final: {
      formatador: formatarValorMonetario,
    },
    diferenca_em_valor: {
      formatador: formatarValorMonetario,
      indicador: {
        positivo: { cor: 'green' },
        negativo: { cor: 'red' },
      }
    },
    diferenca_em_porcentagem: {
      formatador: valor => `${formatarValorComCasas(valor, 1)}%`,
      indicador: {
        positivo: { cor: 'green' },
        negativo: { cor: 'red' },
      }
    },
  },
  estoque_saudavel_versos_estoque_total: {
    descricao: 'Estoque saudável x Estoque total (%)',
    valor_data_inicial: {
      formatador: valor => `${formatarValor(valor)}%`,
    },
    valor_data_final: {
      formatador: valor => `${formatarValor(valor)}%`,
    },
    diferenca_em_valor: {
      formatador: valor => `${formatarValor(valor)}%`,
      indicador: {
        positivo: { cor: 'green' },
        negativo: { cor: 'red' },
      }
    },
    diferenca_em_porcentagem: {
      formatador: valor => `${formatarValorComCasas(valor, 1)}%`,
      indicador: {
        positivo: { cor: 'green' },
        negativo: { cor: 'red' },
      }
    },
  },
  faturamento_ult_mes_fechado_em_preco_venda: {
    descricao: 'Faturamento do Último Mês Fechado (R$ venda)',
    valor_data_inicial: {
      formatador: formatarValorMonetario,
    },
    valor_data_final: {
      formatador: formatarValorMonetario,
    },
    diferenca_em_valor: {
      formatador: formatarValorMonetario,
      indicador: {
        positivo: { cor: 'green' },
        negativo: { cor: 'red' },
      }
    },
    diferenca_em_porcentagem: {
      formatador: valor => `${formatarValorComCasas(valor, 1)}%`,
      indicador: {
        positivo: { cor: 'green' },
        negativo: { cor: 'red' },
      }
    },
  },
  margem_media_em_porcentagem: {
    descricao: 'Margem média do último mês fechado (%)',
    valor_data_inicial: {
      formatador: valor => `${formatarValor(valor)}%`,
    },
    valor_data_final: {
      formatador: valor => `${formatarValor(valor)}%`,
    },
    diferenca_em_valor: {
      formatador: valor => `${formatarValor(valor)}%`,
      indicador: {
        positivo: { cor: 'green' },
        negativo: { cor: 'red' },
      }
    },
    diferenca_em_porcentagem: {
      formatador: valor => `${formatarValorComCasas(valor, 1)}%`,
      indicador: {
        positivo: { cor: 'green' },
        negativo: { cor: 'red' },
      }
    },
  },
  estoque_parado_a_pelo_menos_2_meses: {
    descricao: 'Estoque sem venda a partir de 2 meses sem vender (R$ Custo)',
    valor_data_inicial: {
      formatador: formatarValorMonetario,
    },
    valor_data_final: {
      formatador: formatarValorMonetario,
    },
    diferenca_em_valor: {
      formatador: formatarValorMonetario,
      indicador: {
        positivo: { cor: 'red' },
        negativo: { cor: 'green' },
      }
    },
    diferenca_em_porcentagem: {
      formatador: valor => `${formatarValorComCasas(valor, 1)}%`,
      indicador: {
        positivo: { cor: 'red' },
        negativo: { cor: 'green' },
      }
    },
  },
  cobertura_media_geral_em_dias: {
    descricao: 'Cobertura Média geral (dias)',
    valor_data_inicial: {
      formatador: valor => `${formatarValor(valor)} dias`,
    },
    valor_data_final: {
      formatador: valor => `${formatarValor(valor)} dias`,
    },
    diferenca_em_valor: {
      formatador: valor => `${formatarValor(valor)} dias`,
      indicador: {
        positivo: { cor: 'green' },
        negativo: { cor: 'red' },
      }
    },
    diferenca_em_porcentagem: {
      formatador: valor => `${formatarValorComCasas(valor, 1)}%`,
      indicador: {
        positivo: { cor: 'green' },
        negativo: { cor: 'red' },
      }
    },
  },
  giro_medio_geral_em_dias: {
    descricao: 'Giro Médio geral (unidades)',
    valor_data_inicial: {
      formatador: formatarValor,
    },
    valor_data_final: {
      formatador: formatarValor,
    },
    diferenca_em_valor: {
      formatador: formatarValor,
      indicador: {
        positivo: { cor: 'red' },
        negativo: { cor: 'green' },
      }
    },
    diferenca_em_porcentagem: {
      formatador: valor => `${formatarValorComCasas(valor, 1)}%`,
      indicador: {
        positivo: { cor: 'red' },
        negativo: { cor: 'green' },
      }
    },
  },
  giro_financeiro_medio_geral_em_dias: {
    descricao: 'Giro Financeiro Médio geral (unidades)',
    valor_data_inicial: {
      formatador: formatarValor,
    },
    valor_data_final: {
      formatador: formatarValor,
    },
    diferenca_em_valor: {
      formatador: formatarValor,
      indicador: {
        positivo: { cor: 'red' },
        negativo: { cor: 'green' },
      }
    },
    diferenca_em_porcentagem: {
      formatador: valor => `${formatarValorComCasas(valor, 1)}%`,
      indicador: {
        positivo: { cor: 'red' },
        negativo: { cor: 'green' },
      }
    },
  },
};
